import Modal from '../Modal';
import { appPath, isBrowser, isProduct } from '@web3/base-utils';
import { useFm } from '@web3/base-hooks';
import { useEffect, useRef } from 'react';

const xLogo = `${appPath}/images/activity/x-logo.svg`;

type IConnectX = {
  show: boolean;
  onCancel: () => void;
  onConnect: (code: string) => void;
};

const clientId = 'dk9kUVhjQ2dCcGtab0t0R0UxNk86MTpjaQ';
const twitterScope = isBrowser
  ? ['tweet.read', 'users.read', 'follows.read', 'offline.access'].join('+')
  : '';

export function ConnectX(props: IConnectX) {
  const { show, onConnect } = props;
  const fm = useFm();
  const popupRef = useRef<Window | null>(null);

  const onOk = () => {
    const redirect_uri =
      // eslint-disable-next-line
      isProduct
        ? // eslint-disable-next-line
          `https://www.bybit.com/web3/airdrop/activity?originUrl=${window.location.origin}`
        : // eslint-disable-next-line
          `https://www.sbu-test-5.bybit.com/web3/airdrop/activity?originUrl=${window.location.origin}`;
    const redirect = window.encodeURIComponent(redirect_uri);
    const authUrl = `https://x.com/i/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirect}&state=state&code_challenge=challenge&code_challenge_method=plain&scope=${twitterScope}`;

    // 获取浏览器窗口的宽度和高度
    const width = 800;
    const height = 600;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;

    // 计算小窗的位置（水平和垂直居中）
    const left = (screenWidth - width) / 2;
    const top = (screenHeight - height) / 2;

    // 构建 window.open 的窗口参数
    const windowFeatures = `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`;

    const pupup = window.open(authUrl, 'twitter-auth', windowFeatures);

    popupRef.current = pupup;
  };

  useEffect(() => {
    if (!show) {
      return;
    }
    const handleAuthMessage = (event) => {
      console.log('event', event);

      // 授权完成，处理返回的数据
      const { code, state } = event.data;

      if (code && state) {
        onConnect(code);
        console.log('popupRef', popupRef?.current);
        popupRef?.current?.close();
      }
    };
    // 监听授权结果
    window.addEventListener('message', handleAuthMessage);

    return () => {
      window.removeEventListener('message', handleAuthMessage);
    };
  }, [show]);

  return (
    <Modal
      visible={show}
      size="small"
      title=""
      onOk={onOk}
      okText={fm('word_connect')}
      cancelText={false}
      onCancel={props.onCancel}
    >
      <div className="text-center">
        <div className="mt-4 flex justify-center">
          <img className="w-18 h-18" src={xLogo} alt="" />
        </div>
        <p className="mt-4 ">{fm('connectYourXAccount')}</p>
        <p className="text-gray1 text-sm font-normal mt-2">
          {fm('afterConnectFollowOfficial')}
        </p>
      </div>
    </Modal>
  );
}
